var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _path, _path2, _path3, _path4, _path5, _g29, _path6, _path7, _path8, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _path9, _path10, _path11, _path12, _path13, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _path14, _path15, _path16, _path17, _path18, _g71, _path19, _path20, _path21, _path22, _path23, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _path24, _path25, _path26, _path27, _path28, _path29, _g87, _g88, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoaPhase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 853.6 1965.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-soa-p1 {\n        fill: url(#soa-linear-gradient-2-p1);\n      }\n\n      .cls-1-soa-p1, .cls-2-soa-p1, .cls-3-soa-p1, .cls-4-soa-p1, .cls-5-soa-p1, .cls-6-soa-p1, .cls-7-soa-p1, .cls-8-soa-p1, .cls-9-soa-p1,.cls-16-soa-p1 {\n        stroke: #1071e5;\n      }\n\n      .cls-16-soa-p1{\n        fill: #fff;\n      }\n\n      .cls-2-soa-p1 {\n        fill: #fff;\n      }\n\n      .cls-10-soa-p1, .cls-11-soa-p1, .cls-12-soa-p1, .cls-13-soa-p1, .cls-14-soa-p1, .cls-15-soa-p1 {\n        stroke-width: 0px;\n      }\n\n      .cls-3-soa-p1, .cls-4-soa-p1, .cls-5-soa-p1, .cls-13-soa-p1 {\n        fill: #1071e5;\n      }\n\n      .cls-11-soa-p1 {\n        fill: #333;\n      }\n\n      .cls-4-soa-p1, .cls-7-soa-p1 {\n        stroke-width: .5px;\n      }\n\n      .cls-5-soa-p1 {\n        stroke-width: .05px;\n      }\n\n      .cls-6-soa-p1 {\n        fill: url(#soa-linear-gradient-3-p1);\n      }\n      .cls-6-soa-p1:hover {\n        fill: url(#soa-linear-gradient-3-p1);\n        pointer-events: none;\n      }\n\n      .cls-7-soa-p1, .cls-8-soa-p1 {\n        fill: none;\n      }\n\n      .cls-12-soa-p1 {\n        fill: #3a414a;\n      }\n\n      .cls-14-soa-p1 {\n        fill: #e81313;\n      }\n\n      .cls-15-soa-p1 {\n        fill: #008a0e;\n      }\n\n      .cls-9-soa-p1 {\n        fill: url(#soa-linear-gradient-1-p1);\n      }\n\n      .cls-16-soa-p1{\n        fill: #fff;\n      }\n      .cls-16-soa-p1:hover{\n        fill: url(#soa-linear-gradient-3-p1);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soa-linear-gradient-1-p1",
    x1: 266.22,
    y1: 2245.9,
    x2: 266.22,
    y2: 1951.21,
    gradientTransform: "translate(-33.12 2766.4) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a3ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5faaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soa-linear-gradient-2-p1",
    x1: 265.55,
    y1: 1878.56,
    x2: 265.55,
    y2: 1583.87,
    gradientTransform: "translate(-33.12 2766.4) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a3ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5faaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soa-linear-gradient-3-p1",
    x1: 571.22,
    y1: 1061.2,
    x2: 571.22,
    y2: 941.2,
    gradientTransform: "translate(-33.12 2766.4) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a3ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5faaff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-soa-p1",
    d: "M593.1,613.84c0-3.31,2.69-6,6-6h248c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-248c-3.31,0-6-2.69-6-6v-108Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "cls-12-soa-p1",
    d: "M645.33,630.25c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "cls-12-soa-p1",
    d: "M658.09,639.96c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM651.78,638.8c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "cls-12-soa-p1",
    d: "M676.36,630.92c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "cls-12-soa-p1",
    d: "M690.21,629.23c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM689.67,641.04c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-2",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M705.55,639.96c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM699.24,638.8c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "cls-12-soa-p1",
    d: "M711.19,626.71v-2.04h2.17v2.04h-2.17ZM711.19,642.4v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "cls-12-soa-p1",
    d: "M726.94,629.5c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM721.31,640.91c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "cls-12-soa-p1",
    d: "M736.45,629.23c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "cls-12-soa-p1",
    d: "M755.67,629.23c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM755.6,641.04c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "cls-12-soa-p1",
    d: "M776.44,642.4h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-2",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M787.99,629.23c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "cls-12-soa-p1",
    d: "M800.41,629.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM803.94,634.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "cls-12-soa-p1",
    d: "M814.94,631.33c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "cls-12-soa-p1",
    d: "M651.67,660.26c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-2",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M664.17,658.56c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM664.1,670.38c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-2",
    "data-name": "aQ",
    className: "cls-12-soa-p1",
    d: "M685.22,660.26c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "cls-12-soa-p1",
    d: "M699.07,658.56c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM698.53,670.38c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "cls-12-soa-p1",
    d: "M706.47,671.73v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-2",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M717,658.56c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM720.53,664.06c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "cls-12-soa-p1",
    d: "M727.79,668.54c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-3",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M737.37,658.56c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM740.9,664.06c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "cls-12-soa-p1",
    d: "M753.32,662.02c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aY-2",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M770.91,660.67c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M772.88,656.05v-2.04h2.17v2.04h-2.17ZM772.88,671.73v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-2",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M785.78,662.02c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "cls-12-soa-p1",
    d: "M798.54,671.73l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aP-3",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M673.64,698.62c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM667.33,697.47c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-3",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M686.81,691.36c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-4",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M699.04,691.36c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-4",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M708.88,687.89c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM712.41,693.39c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-5",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M724.84,691.36c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-3",
    "data-name": "aQ",
    className: "cls-12-soa-p1",
    d: "M742.15,689.59c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-5",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M754.99,687.89c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM758.52,693.39c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-3",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M769.72,687.89c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-2",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M779.36,697.88c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9-soa-p1",
    d: "M228.02,523.7c3.11-1.95,7.06-1.95,10.17,0l225.07,140.95c1.76,1.1,2.29,3.42,1.19,5.18-.3.48-.71.89-1.19,1.19l-225.06,140.98c-3.11,1.95-7.06,1.95-10.17,0L2.94,671.03c-1.76-1.1-2.29-3.42-1.19-5.18.3-.48.71-.89,1.19-1.19l225.08-140.96Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "cls-10-soa-p1",
    d: "M218.26,546.03c8.15-.48,15.14.34,15.01,8.28-.07,5.43-2.99,8.56-8.22,8.56h-6.79v-16.84ZM221.79,560.15c5.02.48,7.94-1.22,7.94-5.84s-3.06-5.98-7.94-5.57v11.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "cls-10-soa-p1",
    d: "M241.69,549.7c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM241.62,560.83c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-10-soa-p1",
    d: "M184.35,589.89c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM181.09,590.1c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "cls-10-soa-p1",
    d: "M198.06,579.03c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "cls-10-soa-p1",
    d: "M212.12,592.88c-1.02,2.92-2.92,5.16-7.06,4.21v-2.38c2.38.54,3.6-.75,4.01-2.65l-5.09-12.77h3.53l3.26,10.05c.81-3.53,1.9-6.79,2.99-10.05h3.46"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf-2",
    "data-name": "bf",
    className: "cls-10-soa-p1",
    d: "M231.61,579.03c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM231.54,590.17c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "cls-10-soa-p1",
    d: "M247.22,576.86c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "cls-10-soa-p1",
    d: "M261.69,592c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "cls-10-soa-p1",
    d: "M269.7,581.54c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "cls-10-soa-p1",
    d: "M289.39,588.94c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM286.33,584.26c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bj-2",
    "data-name": "bj",
    className: "cls-10-soa-p1",
    d: "M148.32,606.19c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-3",
    "data-name": "bf",
    className: "cls-10-soa-p1",
    d: "M155.66,608.36c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM155.59,619.5c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn",
    className: "cls-10-soa-p1",
    d: "M164.76,621.54v-17.72h3.4v17.72h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn-2",
    "data-name": "bn",
    className: "cls-10-soa-p1",
    d: "M171.55,621.54v-17.72h3.4v17.72h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-4",
    "data-name": "bf",
    className: "cls-10-soa-p1",
    d: "M184.11,608.36c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM184.04,619.5c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo",
    className: "cls-10-soa-p1",
    d: "M207.19,621.54h-3.53l-2.65-10.52-2.72,10.52h-3.53l-3.33-12.9h3.12l2.17,9.85c.61-3.53,1.63-6.59,2.44-9.85h3.6l2.51,9.85,2.17-9.85h3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp",
    className: "cls-10-soa-p1",
    d: "M212.22,606.33v-2.51h3.4v2.51h-3.4ZM212.22,621.54v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-2",
    "data-name": "bh",
    className: "cls-10-soa-p1",
    d: "M226.48,608.36c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq",
    className: "cls-10-soa-p1",
    d: "M245.42,621.13c.75,5.98-8.15,7.2-11.14,3.53-.27-.41-.41-.88-.54-1.43l3.33-.41c.2,1.09,1.09,1.63,2.31,1.7,2.72,0,2.85-2.51,2.72-5.36-.75,1.49-2.04,2.38-4.14,2.38-3.6,0-4.75-2.92-4.75-6.59s1.22-6.52,4.96-6.59c2.04,0,3.12.95,4.01,2.31l.14-2.04h3.19l-.07,12.49ZM239.31,619.16c2.17,0,2.78-1.83,2.78-4.28s-.61-4.21-2.72-4.21-2.65,1.97-2.72,4.28c0,2.44.61,4.21,2.65,4.21"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-10-soa-p1",
    d: "M262.87,619.23c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM259.61,619.43c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br",
    className: "cls-10-soa-p1",
    d: "M276.59,608.36c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM275.16,619.5c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-2",
    "data-name": "br",
    className: "cls-10-soa-p1",
    d: "M291.46,608.36c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM290.03,619.5c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn-3",
    "data-name": "bn",
    className: "cls-10-soa-p1",
    d: "M298.86,621.54v-17.72h3.4v17.72h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-2",
    "data-name": "bi",
    className: "cls-10-soa-p1",
    d: "M312.31,622.22c-1.02,2.92-2.92,5.16-7.06,4.21v-2.38c2.38.54,3.6-.75,4.01-2.65l-5.09-12.77h3.53l3.26,10.05c.81-3.53,1.9-6.79,2.99-10.05h3.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs",
    className: "cls-10-soa-p1",
    d: "M319.91,612.57v-3.4h3.4v3.4h-3.4ZM319.91,621.54v-3.33h3.4v3.33h-3.4"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bt",
    className: "cls-10-soa-p1",
    d: "M175.51,637.7c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu",
    className: "cls-10-soa-p1",
    d: "M187.94,637.7c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM191.47,643.2c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv",
    className: "cls-10-soa-p1",
    d: "M208.71,650.87h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bw",
    className: "cls-10-soa-p1",
    d: "M226.44,650.87h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-2",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M238.11,637.7c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM241.65,643.2c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-2",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M252.85,637.7c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx",
    className: "cls-10-soa-p1",
    d: "M264.26,637.7c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM264.87,639.33c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by",
    className: "cls-10-soa-p1",
    d: "M278.86,637.7c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM278.79,649.51c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz",
    className: "cls-10-soa-p1",
    d: "M293.39,639.8c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA",
    className: "cls-10-soa-p1",
    d: "M296.99,648.29c.07,2.31,0,4.41-.95,5.7h-1.49c.61-.88,1.15-1.77,1.15-3.12h-1.09v-2.58h2.38"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bt-3",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M61.07,667.03c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-3",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M73.5,667.03c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM77.03,672.53c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv-2",
    "data-name": "bv",
    className: "cls-10-soa-p1",
    d: "M94.28,680.2h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bB",
    className: "cls-10-soa-p1",
    d: "M108.67,677.01c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC",
    className: "cls-10-soa-p1",
    d: "M121.03,677.76c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM114.71,676.6c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bD",
    className: "cls-10-soa-p1",
    d: "M131.55,668.73c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-2",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M141.26,677.01c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE",
    className: "cls-10-soa-p1",
    d: "M145.68,664.52v-2.04h2.17v2.04h-2.17ZM145.68,680.2v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bD-2",
    "data-name": "bD",
    className: "cls-10-soa-p1",
    d: "M155.93,668.73c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bB-3",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M172.43,677.01c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bF",
    className: "cls-10-soa-p1",
    d: "M187.37,667.3l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bG",
    className: "cls-10-soa-p1",
    d: "M195.24,667.03c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM194.7,678.84c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-4",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M207.81,667.03c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM211.34,672.53c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bv-3",
    "data-name": "bv",
    className: "cls-10-soa-p1",
    d: "M235.37,680.2h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-2",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M240.6,664.52v-2.04h2.17v2.04h-2.17ZM240.6,680.2v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-4",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M248.34,677.01c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bH",
    className: "cls-10-soa-p1",
    d: "M258.32,668.73c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bu-5",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M278.29,667.03c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM281.82,672.53c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bI",
    className: "cls-10-soa-p1",
    d: "M294.65,680.2l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-3",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M298.93,664.52v-2.04h2.17v2.04h-2.17ZM298.93,680.2v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ",
    className: "cls-10-soa-p1",
    d: "M311.83,670.49c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-5",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M318.89,677.01c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-4",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M323.31,664.52v-2.04h2.17v2.04h-2.17ZM323.31,680.2v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-4",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M334.99,667.03c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bK",
    className: "cls-10-soa-p1",
    d: "M352.64,667.3c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM347,678.71c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bL",
    className: "cls-10-soa-p1",
    d: "M373.55,667.37c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bM",
    className: "cls-10-soa-p1",
    d: "M386.79,663.16c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM386.79,678.57c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bN",
    className: "cls-10-soa-p1",
    d: "M410.22,680.2l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM407.64,673.48l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA-2",
    "data-name": "bA",
    className: "cls-10-soa-p1",
    d: "M417.21,677.62c.07,2.31,0,4.41-.95,5.7h-1.49c.61-.88,1.15-1.77,1.15-3.12h-1.09v-2.58h2.38"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "by-2",
    "data-name": "by",
    className: "cls-10-soa-p1",
    d: "M95.05,696.36c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM94.98,708.18c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-6",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M105.84,706.34c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bH-2",
    "data-name": "bH",
    className: "cls-10-soa-p1",
    d: "M115.82,698.06c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-6",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M129,696.36c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM132.53,701.86c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz-2",
    "data-name": "bz",
    className: "cls-10-soa-p1",
    d: "M143.53,698.47c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bE-5",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M152.29,693.85v-2.04h2.17v2.04h-2.17ZM152.29,709.54v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-2",
    "data-name": "bx",
    className: "cls-10-soa-p1",
    d: "M161.79,696.36c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM162.4,697.99c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-7",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M176.39,696.36c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM179.92,701.86c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-5",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M191.13,696.36c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-7",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M200.77,706.34c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-6",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M205.18,693.85v-2.04h2.17v2.04h-2.17ZM205.18,709.54v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bO",
    className: "cls-10-soa-p1",
    d: "M215.78,693.65c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-7",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M217.34,693.85v-2.04h2.17v2.04h-2.17ZM217.34,709.54v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-8",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M227.86,696.36c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM231.39,701.86c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-3",
    "data-name": "bx",
    className: "cls-10-soa-p1",
    d: "M240.42,696.36c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM241.03,697.99c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bz-3",
    "data-name": "bz",
    className: "cls-10-soa-p1",
    d: "M262.76,698.47c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-8",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M264.73,693.85v-2.04h2.17v2.04h-2.17ZM264.73,709.54v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ-2",
    "data-name": "bJ",
    className: "cls-10-soa-p1",
    d: "M277.63,699.83c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bP",
    className: "cls-10-soa-p1",
    d: "M290.4,709.54l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ-3",
    "data-name": "bJ",
    className: "cls-10-soa-p1",
    d: "M302.08,699.83c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bQ",
    className: "cls-10-soa-p1",
    d: "M319.73,696.36c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM319.19,708.18c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-2",
    "data-name": "bC",
    className: "cls-10-soa-p1",
    d: "M335.08,707.09c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM328.76,705.94c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ-4",
    "data-name": "bJ",
    className: "cls-10-soa-p1",
    d: "M348.25,699.83c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-9",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M358.1,696.36c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM361.63,701.86c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-4",
    "data-name": "bx",
    className: "cls-10-soa-p1",
    d: "M370.66,696.36c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM371.27,697.99c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "by-3",
    "data-name": "by",
    className: "cls-10-soa-p1",
    d: "M135.62,725.7c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM135.55,737.51c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-6",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M150.35,725.7c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bB-8",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M166.78,735.68c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bH-3",
    "data-name": "bH",
    className: "cls-10-soa-p1",
    d: "M176.77,727.39c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-10",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M189.94,725.7c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM193.47,731.2c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bN-2",
    "data-name": "bN",
    className: "cls-10-soa-p1",
    d: "M217.44,738.87l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM214.86,732.15l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ-5",
    "data-name": "bJ",
    className: "cls-10-soa-p1",
    d: "M228.98,729.16c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ-6",
    "data-name": "bJ",
    className: "cls-10-soa-p1",
    d: "M241.2,729.16c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-11",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M251.05,725.7c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM254.58,731.2c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ-7",
    "data-name": "bJ",
    className: "cls-10-soa-p1",
    d: "M267.01,729.16c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bR",
    className: "cls-10-soa-p1",
    d: "M284.32,727.39c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-12",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M297.15,725.7c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM300.69,731.2c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-7",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M311.89,725.7c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-9",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M321.53,735.68c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bS",
    className: "cls-10-soa-p1",
    d: "M331.31,721.83c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM329.54,738.87v-2.38h2.31v2.38h-2.31"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M494.42,668.34h-28.38v-1h28.38v1ZM576.22,668.34h-32.9v-1h32.9v1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M466.06,668.34h-.58l.06-.5-.06-.5h.57v1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M466.06,668.37h-.6l.05-.53-.05-.52h.6v1.05ZM465.51,667.37l.05.47-.05.48h.5v-.95h-.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M590.99,667.84l-14.27,4.64v-9.27l14.27,4.63Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M592.6,667.84l-16.38,5.33v-10.65l16.38,5.32ZM577.22,671.79l12.15-3.96-12.14-3.94v7.9Z"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bT",
    className: "cls-15-soa-p1",
    d: "M504.33,665.81v6.93h-3.53v-6.93l-5.98-9.91h3.67l4.07,7.13,4.07-7.13h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU",
    className: "cls-15-soa-p1",
    d: "M512.35,672.73v-16.84h13.24v2.72h-9.71v4.28h8.96v2.72h-8.96v4.41h10.19v2.72h-13.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV",
    className: "cls-15-soa-p1",
    d: "M538.49,660.38c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M232.93,872.68h-1v-8.9h1v8.9ZM232.93,834.46h-1v-24.76h1v24.76ZM232.93,809.7h-1v-.5h1v.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M232.43,887.45l-4.63-14.27h9.26l-4.63,14.27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M232.43,889.07l-5.32-16.4h10.65l-5.33,16.4ZM228.49,873.67l3.94,12.16,3.95-12.15h-7.89Z"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bW",
    className: "cls-14-soa-p1",
    d: "M226.02,854.02l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bX",
    className: "cls-14-soa-p1",
    d: "M241.23,836.97c5.43,0,8.49,3.06,8.49,8.56s-3.12,8.76-8.56,8.76-8.42-3.26-8.42-8.76,2.99-8.56,8.49-8.56ZM241.16,851.5c3.53,0,4.96-2.38,4.96-5.98,0-3.4-1.43-5.84-4.89-5.84s-4.96,2.38-4.96,5.84,1.49,5.98,4.89,5.98"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-soa-p1",
    d: "M227.36,891.03c3.11-1.94,7.05-1.94,10.16,0l225.08,140.97c1.76,1.1,2.29,3.42,1.19,5.18-.3.48-.71.89-1.19,1.19l-225.08,140.98c-3.11,1.95-7.06,1.95-10.17,0L2.26,1038.37c-1.76-1.1-2.29-3.42-1.19-5.18.3-.48.71-.89,1.19-1.19l225.1-140.97Z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bY",
    className: "cls-10-soa-p1",
    d: "M114.82,996.25v14.12h-3.53v-14.12h-5.43v-2.72h14.4v2.72h-5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bZ",
    className: "cls-10-soa-p1",
    d: "M133.09,1010.37v-7.2h-7.47v7.2h-3.53v-16.84h3.53v6.72h7.47v-6.72h3.4v16.84h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ca",
    className: "cls-10-soa-p1",
    d: "M154.34,998.55c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM143.2,1001.27c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cb",
    className: "cls-10-soa-p1",
    d: "M157.26,1010.37v-16.84h13.24v2.72h-9.71v4.28h8.96v2.72h-8.96v4.41h10.19v2.72h-13.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cc",
    className: "cls-10-soa-p1",
    d: "M183.4,998.01c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bZ-2",
    "data-name": "bZ",
    className: "cls-10-soa-p1",
    d: "M200.85,1010.37v-7.2h-7.47v7.2h-3.53v-16.84h3.53v6.72h7.47v-6.72h3.4v16.84h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cd",
    className: "cls-10-soa-p1",
    d: "M215.32,993.33c5.43,0,8.49,3.06,8.49,8.56s-3.12,8.76-8.56,8.76-8.42-3.26-8.42-8.76,2.99-8.56,8.49-8.56ZM215.25,1007.86c3.53,0,4.96-2.38,4.96-5.98,0-3.4-1.43-5.84-4.89-5.84s-4.96,2.38-4.96,5.84,1.49,5.98,4.89,5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ce",
    className: "cls-10-soa-p1",
    d: "M226.45,1010.37v-16.84h3.53v14.12h9.03v2.72h-12.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be-2",
    "data-name": "be",
    className: "cls-10-soa-p1",
    d: "M241.32,993.53c8.15-.48,15.14.34,15.01,8.28-.07,5.43-2.99,8.56-8.22,8.56h-6.79v-16.84ZM244.85,1007.65c5.02.48,7.94-1.22,7.94-5.84s-3.06-5.98-7.94-5.57v11.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-soa-p1",
    d: "M104.37,1011.67h160.92v2.6H104.39l-.02-2.6Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cf",
    className: "cls-10-soa-p1",
    d: "M268.62,1001.88c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bZ-3",
    "data-name": "bZ",
    className: "cls-10-soa-p1",
    d: "M294.29,1010.37v-7.2h-7.47v7.2h-3.53v-16.84h3.53v6.72h7.47v-6.72h3.4v16.84h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cb-2",
    "data-name": "cb",
    className: "cls-10-soa-p1",
    d: "M300.87,1010.37v-16.84h13.24v2.72h-9.71v4.28h8.96v2.72h-8.96v4.41h10.19v2.72h-13.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cf-2",
    "data-name": "cf",
    className: "cls-10-soa-p1",
    d: "M320.09,1001.88c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cg",
    className: "cls-10-soa-p1",
    d: "M346.37,1010.37l-5.98-7.74-2.1,1.63v6.11h-3.53v-16.84h3.53v7.67l7.6-7.67h4.07l-7.2,7.13,7.81,9.71h-4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-2",
    "data-name": "bs",
    className: "cls-10-soa-p1",
    d: "M353.09,1001.41v-3.4h3.4v3.4h-3.4ZM353.09,1010.37v-3.33h3.4v3.33h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-soa-p1",
    d: "M262.85,1011.67h97.17v2.6h-97.17v-2.6Z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ch",
    className: "cls-10-soa-p1",
    d: "M81.75,1039.7v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ-8",
    "data-name": "bJ",
    className: "cls-10-soa-p1",
    d: "M95.47,1029.99c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "A-2",
    "data-name": "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bB-10",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M109.32,1036.51c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bH-4",
    "data-name": "bH",
    className: "cls-10-soa-p1",
    d: "M119.3,1028.23c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-13",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M132.48,1026.53c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM136.01,1032.03c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bw-2",
    "data-name": "bw",
    className: "cls-10-soa-p1",
    d: "M153.39,1039.7h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-3",
    "data-name": "bC",
    className: "cls-10-soa-p1",
    d: "M167.85,1037.26c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM161.54,1036.1c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ci",
    className: "cls-10-soa-p1",
    d: "M173.49,1039.7v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cj",
    className: "cls-10-soa-p1",
    d: "M182.93,1039.97c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-14",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M197.59,1026.53c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM201.12,1032.03c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "by-4",
    "data-name": "by",
    className: "cls-10-soa-p1",
    d: "M217.96,1026.53c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM217.9,1038.34c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bO-2",
    "data-name": "bO",
    className: "cls-10-soa-p1",
    d: "M231.61,1023.81c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "A-3",
    "data-name": "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bB-11",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M242.34,1036.51c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bH-5",
    "data-name": "bH",
    className: "cls-10-soa-p1",
    d: "M252.32,1028.23c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-15",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M265.49,1026.53c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM269.03,1032.03c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bD-3",
    "data-name": "bD",
    className: "cls-10-soa-p1",
    d: "M285.59,1028.23c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-4",
    "data-name": "bC",
    className: "cls-10-soa-p1",
    d: "M300.87,1037.26c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM294.56,1036.1c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bR-2",
    "data-name": "bR",
    className: "cls-10-soa-p1",
    d: "M319.14,1028.23c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bG-2",
    "data-name": "bG",
    className: "cls-10-soa-p1",
    d: "M332.99,1026.53c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM332.45,1038.34c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-5",
    "data-name": "bC",
    className: "cls-10-soa-p1",
    d: "M348.33,1037.26c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM342.02,1036.1c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-9",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M353.97,1024.02v-2.04h2.17v2.04h-2.17ZM353.97,1039.7v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bK-2",
    "data-name": "bK",
    className: "cls-10-soa-p1",
    d: "M369.72,1026.8c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM364.09,1038.21c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-8",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M379.23,1026.53c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "by-5",
    "data-name": "by",
    className: "cls-10-soa-p1",
    d: "M145.31,1055.86c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM145.24,1067.68c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw-3",
    "data-name": "bw",
    className: "cls-10-soa-p1",
    d: "M159.43,1069.04h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-16",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M171.11,1055.86c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM174.64,1061.36c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz-4",
    "data-name": "bz",
    className: "cls-10-soa-p1",
    d: "M185.64,1057.97c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ck",
    className: "cls-10-soa-p1",
    d: "M195.83,1067.2c3.12-.27,7.94,1.15,8.15-2.1l1.97.2c-.34,2.24-1.43,3.73-4.01,3.73h-8.35v-1.83c1.83-.81,2.24-2.85,2.1-5.64h-2.24v-1.56h2.24c-1.56-6.52,3.87-10.39,8.69-6.52.27.34.54.75.68,1.22l-2.1.68c-.34-1.02-1.09-1.63-2.44-1.63-3.19,0-2.65,3.26-2.65,6.25h4.82v1.56h-4.82c.14,2.72-.41,4.75-2.04,5.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cl",
    className: "cls-10-soa-p1",
    d: "M213.21,1051.99c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cm",
    className: "cls-10-soa-p1",
    d: "M223.6,1059.39c3.26-2.38,9.3-.54,8.9,4.14.75,6.72-10.46,7.74-11.61,1.77l2.17-.27c.48,1.56,1.49,2.51,3.53,2.51,2.38-.07,3.46-1.49,3.67-3.94.27-3.73-4.96-4.41-6.72-2.31h-2.1l.54-9.1h9.57v1.83h-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bP-2",
    "data-name": "bP",
    className: "cls-10-soa-p1",
    d: "M243.22,1069.04l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cn",
    className: "cls-10-soa-p1",
    d: "M252.53,1069.31l4.89-17.99h1.9l-4.89,17.99h-1.9"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "co",
    className: "cls-10-soa-p1",
    d: "M279.28,1064.28c0,3.12-2.31,4.35-5.5,4.48v1.97h-1.49v-1.97c-3.33-.07-5.36-1.56-5.91-4.28l2.04-.41c.34,1.9,1.7,2.78,3.87,2.92v-5.91c-2.58-.61-5.16-1.36-5.16-4.55.07-2.85,2.24-3.94,5.16-4.01v-1.56h1.49v1.56c3.06,0,4.55,1.36,5.16,3.8l-2.1.41c-.34-1.56-1.22-2.38-3.06-2.51v5.3c2.78.68,5.5,1.36,5.5,4.75ZM273.78,1067.07c3.46.48,4.82-4.48,1.29-5.23-.41-.14-.81-.27-1.29-.41v5.64ZM272.29,1054.17c-3.19-.41-4.28,3.87-1.22,4.69.41.14.81.2,1.22.34v-5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp",
    className: "cls-10-soa-p1",
    d: "M288.24,1060.41c2.24.41,3.94,1.36,3.94,4.01,0,5.98-9.44,6.25-11.14,1.97-.2-.54-.34-1.09-.41-1.7l2.17-.2c.41,1.83,1.43,2.99,3.67,2.99s3.53-1.02,3.53-3.12c0-2.58-2.44-3.12-5.36-2.92v-1.9c2.65.07,4.89-.27,4.89-2.85,0-1.83-1.15-2.92-3.12-2.92s-3.19,1.02-3.33,2.78l-2.17-.2c.41-2.85,2.38-4.28,5.5-4.35,3.26-.07,5.36,1.43,5.36,4.41,0,2.44-1.43,3.53-3.53,4.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cq",
    className: "cls-10-soa-p1",
    d: "M300.12,1051.99c4.62,0,5.77,3.73,5.77,8.62s-1.36,8.69-5.84,8.69-5.84-3.8-5.84-8.69,1.15-8.62,5.91-8.62ZM300.06,1067.54c3.19,0,3.67-3.33,3.67-6.93s-.27-6.93-3.6-6.93-3.73,3.26-3.73,6.93.34,6.93,3.67,6.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bP-3",
    "data-name": "bP",
    className: "cls-10-soa-p1",
    d: "M316.56,1069.04l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bS-2",
    "data-name": "bS",
    className: "cls-10-soa-p1",
    d: "M326.06,1051.99c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM324.3,1069.04v-2.38h2.31v2.38h-2.31"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M723.6,918.3h-1v-57.45h1v57.45ZM723.6,802.18h-1v-73.34h1v73.34Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M723.6,728.86h-1v-.52h1v.52Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M723.63,728.88h-1.05v-.56h1.05v.56ZM722.63,728.38v.45h.95v-.46h-.95Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M723.1,933.07l-4.63-14.27h9.28l-4.65,14.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M723.1,934.7l-5.32-16.4h10.65l-5.33,16.4ZM719.16,919.3l3.94,12.15,3.96-12.15h-7.9Z"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cr",
    className: "cls-11-soa-p1",
    d: "M626.14,821.74h-4.14l-2.99-13.31-2.99,13.31h-4.21l-4.35-16.84h3.6l2.99,13.51,3.06-13.51h3.94l2.92,13.51,2.99-13.51h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cs",
    className: "cls-11-soa-p1",
    d: "M638.64,819.43c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM635.38,819.63c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ct",
    className: "cls-11-soa-p1",
    d: "M644.88,806.53v-2.51h3.4v2.51h-3.4ZM644.88,821.74v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu",
    className: "cls-11-soa-p1",
    d: "M657.79,821.53c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cv",
    className: "cls-11-soa-p1",
    d: "M670.62,822.01c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cw",
    className: "cls-11-soa-p1",
    d: "M688.88,808.57c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu-2",
    "data-name": "cu",
    className: "cls-11-soa-p1",
    d: "M702.4,821.53c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ct-2",
    "data-name": "ct",
    className: "cls-11-soa-p1",
    d: "M704.37,806.53v-2.51h3.4v2.51h-3.4ZM704.37,821.74v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cx",
    className: "cls-11-soa-p1",
    d: "M711.16,821.74v-17.72h3.4v17.72h-3.4"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cy",
    className: "cls-11-soa-p1",
    d: "M734.51,809.38c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cz",
    className: "cls-11-soa-p1",
    d: "M748.84,804.69c5.43,0,8.49,3.06,8.49,8.56s-3.12,8.76-8.56,8.76-8.42-3.26-8.42-8.76,2.99-8.56,8.49-8.56ZM748.77,819.23c3.53,0,4.96-2.38,4.96-5.98,0-3.4-1.43-5.84-4.89-5.84s-4.96,2.38-4.96,5.84,1.49,5.98,4.89,5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cA",
    className: "cls-11-soa-p1",
    d: "M771.86,821.74l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46ZM769.62,814.81l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cB",
    className: "cls-11-soa-p1",
    d: "M783.47,821.74v-16.84h3.53v14.12h9.03v2.72h-12.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cC",
    className: "cls-11-soa-p1",
    d: "M809.27,818.48c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM806.22,813.79c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cs-2",
    "data-name": "cs",
    className: "cls-11-soa-p1",
    d: "M819.32,819.43c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM816.06,819.63c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cD",
    className: "cls-11-soa-p1",
    d: "M829.85,808.57c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM831,819.7c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cE",
    className: "cls-11-soa-p1",
    d: "M620.37,846.79c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cF",
    className: "cls-11-soa-p1",
    d: "M628.52,837.9c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM628.45,849.03c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cw-2",
    "data-name": "cw",
    className: "cls-11-soa-p1",
    d: "M645.09,837.9c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cG",
    className: "cls-11-soa-p1",
    d: "M659.01,835.73c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ct-3",
    "data-name": "ct",
    className: "cls-11-soa-p1",
    d: "M660.57,835.86v-2.51h3.4v2.51h-3.4ZM660.57,851.07v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cH",
    className: "cls-11-soa-p1",
    d: "M674.83,840.89c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cI",
    className: "cls-11-soa-p1",
    d: "M690.11,840.41c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cJ",
    className: "cls-11-soa-p1",
    d: "M706.2,841.7c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cw-3",
    "data-name": "cw",
    className: "cls-11-soa-p1",
    d: "M726.43,837.9c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cC-2",
    "data-name": "cC",
    className: "cls-11-soa-p1",
    d: "M744.7,847.81c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM741.64,843.13c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cK",
    className: "cls-11-soa-p1",
    d: "M755.5,851.07l-2.99-4.69-3.06,4.69h-3.6l4.75-6.65-4.48-6.25h3.6l2.78,4.21,2.72-4.21h3.67l-4.55,6.18,4.82,6.72h-3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu-3",
    "data-name": "cu",
    className: "cls-11-soa-p1",
    d: "M767.11,850.87c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cJ-2",
    "data-name": "cJ",
    className: "cls-11-soa-p1",
    d: "M783.47,841.7c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu-4",
    "data-name": "cu",
    className: "cls-11-soa-p1",
    d: "M795.56,850.87c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cC-3",
    "data-name": "cC",
    className: "cls-11-soa-p1",
    d: "M808.39,847.81c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM805.33,843.13c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cL",
    className: "cls-11-soa-p1",
    d: "M818.58,837.9c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM817.15,849.03c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cJ-3",
    "data-name": "cJ",
    className: "cls-11-soa-p1",
    d: "M833.58,841.7c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-soa-p1",
    d: "M593.1,941.2c0-3.31,2.69-6,6-6h248c3.31,0,6,2.69,6,6v188c0,3.31-2.69,6-6,6h-248c-3.31,0-6-2.69-6-6v-188Z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cM",
    className: "cls-12-soa-p1",
    d: "M610.53,949.9c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM612.77,958.39c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-3",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M632.53,955.68c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-3",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M639.66,953.57c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM639.59,965.39c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-2",
    "data-name": "aZ",
    className: "cls-12-soa-p1",
    d: "M652.96,955.27c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cN",
    className: "cls-12-soa-p1",
    d: "M664.37,967.01c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-4",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M679.99,955.68c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-6",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M687.12,953.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM690.65,959.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-4",
    "data-name": "aQ",
    className: "cls-12-soa-p1",
    d: "M708.17,955.27c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-7",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M721,953.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM724.53,959.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-4",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M735.74,953.57c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-3",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M745.38,963.55c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aP-4",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M764.53,964.3c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM758.21,963.14c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cO",
    className: "cls-12-soa-p1",
    d: "M774.3,953.57c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM774.92,955.2c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cP",
    className: "cls-12-soa-p1",
    d: "M789.45,966.74h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-3",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M795.96,951.06v-2.04h2.17v2.04h-2.17ZM795.96,966.74v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-6",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M808.87,957.03c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-8",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M818.71,953.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM822.24,959.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-7",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M834.67,957.03c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aV-4",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M653.24,982.9c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM653.17,994.72c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-5",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M667.97,982.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ-3",
    "data-name": "aZ",
    className: "cls-12-soa-p1",
    d: "M686.92,984.6c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-5",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M699.41,982.9c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM699.34,994.72c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-6",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M714.14,982.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-4",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M723.79,992.88c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-5",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M734.31,985.01c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-5",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M744.22,993.63c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM737.91,992.48c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-4",
    "data-name": "aZ",
    className: "cls-12-soa-p1",
    d: "M754.75,984.6c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-5",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M764.46,992.88c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-4",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M768.87,980.39v-2.04h2.17v2.04h-2.17ZM768.87,996.08v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-7",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M780.55,982.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-2",
    "data-name": "aT",
    className: "cls-12-soa-p1",
    d: "M798.21,983.18c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM792.57,994.58c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cQ",
    className: "cls-12-soa-p1",
    d: "M653.51,1023.1c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM650.25,1023.3c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cR",
    className: "cls-12-soa-p1",
    d: "M667.22,1012.24c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM665.8,1023.37c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cR-2",
    "data-name": "cR",
    className: "cls-12-soa-p1",
    d: "M682.09,1012.24c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM680.67,1023.37c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cS",
    className: "cls-12-soa-p1",
    d: "M696.96,1015.22c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cT",
    className: "cls-12-soa-p1",
    d: "M704.77,1012.24c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM704.71,1023.37c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cQ-2",
    "data-name": "cQ",
    className: "cls-12-soa-p1",
    d: "M721.21,1023.1c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM717.95,1023.3c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cU",
    className: "cls-12-soa-p1",
    d: "M738.66,1021.13c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cV",
    className: "cls-12-soa-p1",
    d: "M747.08,1014.75c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aP-6",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M770.57,1022.97c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM764.25,1021.81c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-8",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M782.52,1012.24c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cO-2",
    "data-name": "cO",
    className: "cls-12-soa-p1",
    d: "M793.93,1012.24c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM794.54,1013.87c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bc-8",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M616.3,1045.03c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cN-2",
    "data-name": "cN",
    className: "cls-12-soa-p1",
    d: "M625.06,1055.01c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-3",
    "data-name": "aR",
    className: "cls-12-soa-p1",
    d: "M640.74,1041.57c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM640.2,1053.39c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-4",
    "data-name": "aR",
    className: "cls-12-soa-p1",
    d: "M654.32,1041.57c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM653.78,1053.39c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-6",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M666.88,1041.57c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM666.82,1053.39c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-6",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M681.42,1043.68c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-6",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M685.76,1051.55c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-9",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M697.71,1045.03c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ-5",
    className: "cls-12-soa-p1",
    d: "M713.08,1043.27c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-7",
    className: "cls-12-soa-p1",
    d: "M725.57,1041.57c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM725.5,1053.39c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-5",
    className: "cls-12-soa-p1",
    d: "M746.62,1043.27c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-5",
    className: "cls-12-soa-p1",
    d: "M760.47,1041.57c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31h-.01ZM759.93,1053.39c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-2",
    className: "cls-12-soa-p1",
    d: "M767.87,1054.74v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-9",
    className: "cls-12-soa-p1",
    d: "M778.4,1041.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65h0ZM781.93,1047.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-7",
    className: "cls-12-soa-p1",
    d: "M789.77,1051.55c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-5",
    className: "cls-12-soa-p1",
    d: "M794.19,1039.06v-2.04h2.17v2.04h-2.17ZM794.19,1054.74v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-8",
    className: "cls-12-soa-p1",
    d: "M804.71,1041.57c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM804.64,1053.39c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-9",
    className: "cls-12-soa-p1",
    d: "M819.45,1041.57c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aP-8",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M616.03,1081.63c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM609.71,1080.48c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-10",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M627.98,1070.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cO-3",
    "data-name": "cO",
    className: "cls-12-soa-p1",
    d: "M639.38,1070.9c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM640,1072.53c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bc-10",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M663.15,1074.37c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-6",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M667.83,1068.39v-2.04h2.17v2.04h-2.17ZM667.83,1084.08v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-3",
    "data-name": "aT",
    className: "cls-12-soa-p1",
    d: "M683.59,1071.18c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM677.95,1082.58c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-11",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M693.09,1070.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-9",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M708.3,1081.63c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM701.99,1080.48c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-8",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M716.32,1080.88c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cN-3",
    "data-name": "cN",
    className: "cls-12-soa-p1",
    d: "M724.8,1084.35c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-7",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M740.42,1073.01c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-10",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M747.55,1070.9c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM751.08,1076.4c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aV-9",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M767.92,1070.9c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM767.85,1082.72c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cW",
    className: "cls-12-soa-p1",
    d: "M781.57,1068.19c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aW-2",
    "data-name": "aW",
    className: "cls-12-soa-p1",
    d: "M802.28,1084.08h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-10",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M812.67,1070.9c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM812.6,1082.72c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-8",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M827.2,1073.01c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd-2",
    "data-name": "bd",
    className: "cls-12-soa-p1",
    d: "M837.25,1084.08l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aV-11",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M674.52,1100.24c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM674.46,1112.05c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-9",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M689.05,1102.34c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cO-4",
    "data-name": "cO",
    className: "cls-12-soa-p1",
    d: "M695.17,1100.24c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM695.78,1101.87c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-11",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M709.76,1100.24c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM713.29,1105.74c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-10",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M724.29,1102.34c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cX",
    className: "cls-12-soa-p1",
    d: "M724.63,1113.68l4.89-17.99h1.9l-4.89,17.99h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cY",
    className: "cls-12-soa-p1",
    d: "M743.99,1100.58c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cM-2",
    "data-name": "cM",
    className: "cls-12-soa-p1",
    d: "M749.76,1096.57c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM752,1105.06c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cZ",
    className: "cls-12-soa-p1",
    d: "M776.1,1113.41l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM773.52,1106.69l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "rect8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-soa-p1",
    d: "M153.1,1255.2c0-3.31,2.69-6,6-6h148c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-148c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    id: "da",
    className: "cls-12-soa-p1",
    d: "M185.95,1268.55v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-7",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M198.17,1267.81v-2.04h2.17v2.04h-2.17ZM198.17,1283.49v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-12",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M209.85,1270.32c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-10",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M225.06,1281.05c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM218.75,1279.89c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-3",
    "data-name": "ba",
    className: "cls-12-soa-p1",
    d: "M230.7,1283.49v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-8",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M236.06,1267.81v-2.04h2.17v2.04h-2.17ZM236.06,1283.49v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-11",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M248.96,1273.78c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-9",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M253.65,1267.81v-2.04h2.17v2.04h-2.17ZM253.65,1283.49v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-13",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M265.33,1270.32c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-4",
    "data-name": "aT",
    className: "cls-12-soa-p1",
    d: "M282.98,1270.59c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM277.34,1282c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    id: "db",
    className: "cls-12-soa-p1",
    d: "M188.39,1312.83h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-12",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M199.67,1299.65c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM199.6,1311.47c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-11",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M214.2,1301.76c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd-3",
    "data-name": "bd",
    className: "cls-12-soa-p1",
    d: "M224.25,1312.83l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dc",
    className: "cls-12-soa-p1",
    d: "M243.05,1295.78c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM243.05,1311.2c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-12",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M260.3,1301.76c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cO-5",
    "data-name": "cO",
    className: "cls-12-soa-p1",
    d: "M266.41,1299.65c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM267.02,1301.28c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-12",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M281.01,1299.65c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM284.54,1305.15c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-13",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M295.54,1301.76c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aW-3",
    "data-name": "aW",
    className: "cls-12-soa-p1",
    d: "M196.24,1342.16h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-10",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M201.46,1326.47v-2.04h2.17v2.04h-2.17ZM201.46,1342.16v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-9",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M209.21,1338.97c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dd",
    className: "cls-12-soa-p1",
    d: "M219.19,1330.68c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cY-2",
    "data-name": "cY",
    className: "cls-12-soa-p1",
    d: "M244.92,1329.33c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dc-2",
    "data-name": "dc",
    className: "cls-12-soa-p1",
    d: "M258.16,1325.12c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM258.16,1340.53c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cZ-2",
    "data-name": "cZ",
    className: "cls-12-soa-p1",
    d: "M281.59,1342.16l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM279.01,1335.44l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M497.08,1035.7h-31.72v-1h31.72v1ZM576.22,1035.7h-30.26v-1h30.26v1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M465.38,1035.7h-.57l.05-.5-.05-.5h.57v1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M465.4,1035.7h-.62l.06-.5-.05-.54h.6v1.04ZM464.84,1034.7l.05.5-.05.46h.5v-.95h-.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M590.99,1035.2l-14.27,4.62v-9.27l14.27,4.65Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M592.6,1035.2l-16.38,5.3v-10.64l16.38,5.34ZM577.22,1039.14l12.15-3.95-12.14-3.96v7.91Z"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "C-2",
    "data-name": "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bT-2",
    "data-name": "bT",
    className: "cls-15-soa-p1",
    d: "M506.99,1033.15v6.93h-3.53v-6.93l-5.98-9.91h3.67l4.07,7.13,4.07-7.13h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU-2",
    "data-name": "bU",
    className: "cls-15-soa-p1",
    d: "M515.01,1040.08v-16.84h13.24v2.72h-9.71v4.28h8.96v2.72h-8.96v4.41h10.19v2.72h-13.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV-2",
    "data-name": "bV",
    className: "cls-15-soa-p1",
    d: "M541.15,1027.72c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M233.6,1232.3h-1v-7.88h1v7.88ZM232.93,1195.08h-1v-13.28h1v13.28Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M232.43,1181.3l.5-.02v.54h-1v-.54l.5.02Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M232.43,1181.28l.53-.03v.6h-1.05v-.6l.52.03ZM231.96,1181.78h.95v-.47l-.48.03-.47-.02v.46Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M233.1,1247.07l-4.63-14.27h9.28l-4.65,14.27Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M233.1,1248.7l-5.32-16.4h10.65l-5.33,16.4ZM229.16,1233.3l3.94,12.15,3.96-12.15h-7.9Z"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "D-2",
    "data-name": "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bW-2",
    "data-name": "bW",
    className: "cls-14-soa-p1",
    d: "M226.02,1214.64l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bX-2",
    "data-name": "bX",
    className: "cls-14-soa-p1",
    d: "M241.23,1197.6c5.43,0,8.49,3.06,8.49,8.56s-3.12,8.76-8.56,8.76-8.42-3.26-8.42-8.76,2.99-8.56,8.49-8.56ZM241.16,1212.13c3.53,0,4.96-2.38,4.96-5.98,0-3.4-1.43-5.84-4.89-5.84s-4.96,2.38-4.96,5.84,1.49,5.98,4.89,5.98"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "rect9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-soa-p1",
    d: "M408.1,1518.53c0-3.31,2.69-6,6-6h248c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-248c-3.31,0-6-2.69-6-6v-108Z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "cls-12-soa-p1",
    d: "M458.11,1549.93c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-11",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M470.88,1559.64c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM464.56,1558.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-6",
    "data-name": "aQ",
    className: "cls-12-soa-p1",
    d: "M489.14,1550.61c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-6",
    "data-name": "aR",
    className: "cls-12-soa-p1",
    d: "M502.99,1548.91c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM502.45,1560.73c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-12",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M518.34,1559.64c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM512.02,1558.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-11",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M523.97,1546.4v-2.04h2.17v2.04h-2.17ZM523.97,1562.09v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-5",
    "data-name": "aT",
    className: "cls-12-soa-p1",
    d: "M539.73,1549.18c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM534.09,1560.59c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-14",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M549.23,1548.91c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dc-3",
    "data-name": "dc",
    className: "cls-12-soa-p1",
    d: "M571.17,1545.04c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM571.17,1560.46c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-4",
    "data-name": "aW",
    className: "cls-12-soa-p1",
    d: "M594.66,1562.09h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-15",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M606.2,1548.91c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-13",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M618.63,1548.91c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM622.16,1554.41c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-14",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M633.16,1551.02c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aY-15",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M492.77,1580.35c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-13",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M502.69,1588.97c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM496.37,1587.82c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-12",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M508.32,1575.73v-2.04h2.17v2.04h-2.17ZM508.32,1591.42v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-12",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M521.22,1581.71c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-14",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M531.07,1578.25c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM534.6,1583.75c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-13",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M547.03,1581.71c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cM-3",
    "data-name": "cM",
    className: "cls-12-soa-p1",
    d: "M558.91,1574.58c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM561.15,1583.07c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dc-4",
    "data-name": "dc",
    className: "cls-12-soa-p1",
    d: "M582.67,1574.38c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM582.67,1589.79c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "rect10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6-soa-p1",
    d: "M278.1,1711.2c0-3.31,2.69-6,6-6h508c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-508c-3.31,0-6-2.69-6-6v-108Z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ch-2",
    "data-name": "ch",
    className: "cls-10-soa-p1",
    d: "M351.17,1770.99v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-9",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M363.67,1757.82c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-10",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M370.93,1755.31v-2.04h2.17v2.04h-2.17ZM370.93,1770.99v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-12",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M378.67,1767.8c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-11",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M383.09,1755.31v-2.04h2.17v2.04h-2.17ZM383.09,1770.99v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-6",
    "data-name": "bC",
    className: "cls-10-soa-p1",
    d: "M396.4,1768.55c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM390.08,1767.39c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-13",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M404.41,1767.8c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-17",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M413.98,1757.82c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM417.51,1763.32c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bD-4",
    "data-name": "bD",
    className: "cls-10-soa-p1",
    d: "M434.08,1759.52c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz-5",
    "data-name": "bz",
    className: "cls-10-soa-p1",
    d: "M447.53,1759.93c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-18",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M454.66,1757.82c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM458.19,1763.32c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-7",
    "data-name": "bC",
    className: "cls-10-soa-p1",
    d: "M471.02,1768.55c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM464.71,1767.39c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-14",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M479.03,1767.8c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-12",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M483.45,1755.31v-2.04h2.17v2.04h-2.17ZM483.45,1770.99v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-6",
    "data-name": "by",
    className: "cls-10-soa-p1",
    d: "M493.97,1757.82c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM493.9,1769.63c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-10",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M508.71,1757.82c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "J-2",
    "data-name": "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "by-7",
    "data-name": "by",
    className: "cls-10-soa-p1",
    d: "M527.92,1757.82c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM527.85,1769.63c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bO-3",
    "data-name": "bO",
    className: "cls-10-soa-p1",
    d: "M541.57,1755.1c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bG-3",
    "data-name": "bG",
    className: "cls-10-soa-p1",
    d: "M556.1,1757.82c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM555.56,1769.63c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ci-2",
    "data-name": "ci",
    className: "cls-10-soa-p1",
    d: "M563.5,1770.99v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-8",
    "data-name": "bC",
    className: "cls-10-soa-p1",
    d: "M576.81,1768.55c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM570.5,1767.39c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-11",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M588.76,1757.82c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-12",
    "data-name": "bt",
    className: "cls-10-soa-p1",
    d: "M602.34,1757.82c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-19",
    "data-name": "bu",
    className: "cls-10-soa-p1",
    d: "M614.77,1757.82c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM618.3,1763.32c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-5",
    "data-name": "bx",
    className: "cls-10-soa-p1",
    d: "M627.33,1757.82c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM627.94,1759.45c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bB-15",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M645.93,1767.8c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-9",
    "data-name": "bC",
    className: "cls-10-soa-p1",
    d: "M658.29,1768.55c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM651.98,1767.39c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bD-5",
    "data-name": "bD",
    className: "cls-10-soa-p1",
    d: "M668.82,1759.52c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-16",
    "data-name": "bB",
    className: "cls-10-soa-p1",
    d: "M678.53,1767.8c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-13",
    "data-name": "bE",
    className: "cls-10-soa-p1",
    d: "M682.94,1755.31v-2.04h2.17v2.04h-2.17ZM682.94,1770.99v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bD-6",
    "data-name": "bD",
    className: "cls-10-soa-p1",
    d: "M693.19,1759.52c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "de",
    className: "cls-10-soa-p1",
    d: "M704.8,1776.09c-2.58-2.85-4.41-6.25-4.41-11.48s1.9-8.56,4.41-11.34h2.1c-2.58,2.78-4.35,6.25-4.35,11.41s1.77,8.62,4.35,11.41h-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ-9",
    "data-name": "bJ",
    className: "cls-10-soa-p1",
    d: "M716.14,1761.28c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "df",
    className: "cls-10-soa-p1",
    d: "M721.44,1753.27c2.58,2.78,4.41,6.25,4.41,11.41s-1.83,8.62-4.41,11.41h-2.1c2.51-2.78,4.35-6.25,4.35-11.41s-1.83-8.62-4.35-11.41h2.1"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "rect11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16-soa-p1",
    d: "M278.1,1851.2c0-3.31,2.69-6,6-6h148c3.31,0,6,2.69,6,6h0v108c0,3.31-2.69,6-6,6h-148c-3.31,0-6-2.69-6-6v-108Z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cY-3",
    "data-name": "cY",
    className: "cls-12-soa-p1",
    d: "M345.54,1881.91c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dc-5",
    "data-name": "dc",
    className: "cls-12-soa-p1",
    d: "M358.79,1877.7c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM358.79,1893.11c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cZ-3",
    "data-name": "cZ",
    className: "cls-12-soa-p1",
    d: "M382.21,1894.74l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM379.63,1888.02l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dg",
    className: "cls-12-soa-p1",
    d: "M325.65,1924.08l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-13",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M331.29,1908.39v-2.04h2.17v2.04h-2.17ZM331.29,1924.08v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-6",
    "data-name": "aZ",
    className: "cls-12-soa-p1",
    d: "M341.54,1912.6c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-16",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M354.98,1913.01c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-13",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M362.11,1910.9c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM362.04,1922.72c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-14",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M378.07,1914.37c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-14",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M382.75,1908.39v-2.04h2.17v2.04h-2.17ZM382.75,1924.08v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-10",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M390.5,1920.89c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-15",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M400.07,1910.9c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM403.6,1916.4c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz-16",
    "data-name": "bz",
    className: "cls-12-soa-p1",
    d: "M416.03,1914.34c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "rect12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16-soa-p1",
    d: "M458.1,1851.2c0-3.31,2.69-6,6-6h148c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-148c-3.31,0-6-2.69-6-6v-108Z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ax-2",
    "data-name": "ax"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cY-4",
    "data-name": "cY",
    className: "cls-12-soa-p1",
    d: "M525.54,1881.91c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dc-6",
    "data-name": "dc",
    className: "cls-12-soa-p1",
    d: "M538.79,1877.7c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM538.79,1893.11c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cZ-4",
    "data-name": "cZ",
    className: "cls-12-soa-p1",
    d: "M562.21,1894.74l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM559.63,1888.02l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dh",
    className: "cls-12-soa-p1",
    d: "M503.51,1915.18c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM496.92,1914.43c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM496.92,1922.24c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-14",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M518.52,1921.63c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM512.2,1920.48c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-16",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M530.47,1910.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-17",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M544.05,1910.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-16",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M556.47,1910.9c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM560,1916.4c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-17",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M571,1913.01c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-15",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M580.51,1914.37c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "rect13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16-soa-p1",
    d: "M638.1,1851.2c0-3.31,2.69-6,6-6h148c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-148c-3.31,0-6-2.69-6-6v-108Z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "aA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cY-5",
    "data-name": "cY",
    className: "cls-12-soa-p",
    d: "M700.59,1880.91c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dc-7",
    "data-name": "dc",
    className: "cls-12-soa-p",
    d: "M713.83,1876.7c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM713.83,1892.11c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cZ-5",
    "data-name": "cZ",
    className: "cls-12-soa-p",
    d: "M737.25,1893.74l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31,0ZM734.67,1887.02l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "di",
    "data-name": "di",
    className: "cls-12-soa-p",
    d: "M681.1,1923.74v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-7",
    "data-name": "aQ",
    className: "cls-12-soa-p",
    d: "M709.62,1912.27c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-15",
    "data-name": "aP",
    className: "cls-12-soa-p",
    d: "M725.23,1921.3c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38h0ZM718.92,1920.14c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-15",
    "data-name": "aS",
    className: "cls-12-soa-p",
    d: "M730.87,1908.06v-2.04h2.17v2.04h-2.17ZM730.87,1923.74v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-4",
    "data-name": "ba",
    className: "cls-12-soa-p",
    d: "M736.23,1923.74v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-16",
    "data-name": "bc",
    className: "cls-12-soa-p",
    d: "M749.13,1914.03c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-soa-p1",
    d: "M143.1,6.5c0-3.31,2.69-6,6-6h168c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-168c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "aC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cY-6",
    "data-name": "cY",
    className: "cls-12-soa-p1",
    d: "M174.47,37.22c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-17",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M185,36.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM188.53,42.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-5",
    "data-name": "ba",
    className: "cls-12-soa-p1",
    d: "M193.42,50.06v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-18",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M203.94,36.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM207.47,42.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-7",
    "data-name": "aZ",
    className: "cls-12-soa-p1",
    d: "M217.25,38.58c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-11",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M226.96,46.87c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-16",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M231.38,34.37v-2.04h2.17v2.04h-2.17ZM231.38,50.06v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-18",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M243.05,36.88c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-6",
    "data-name": "aT",
    className: "cls-12-soa-p1",
    d: "M260.71,37.16c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM255.07,48.56c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dj",
    className: "cls-12-soa-p1",
    d: "M277.62,41.43c2.24.41,3.94,1.36,3.94,4.01,0,5.98-9.44,6.25-11.14,1.97-.2-.54-.34-1.09-.41-1.7l2.17-.2c.41,1.83,1.43,2.99,3.67,2.99s3.53-1.02,3.53-3.12c0-2.58-2.44-3.12-5.36-2.92v-1.9c2.65.07,4.89-.27,4.89-2.85,0-1.83-1.15-2.92-3.12-2.92s-3.19,1.02-3.33,2.78l-2.17-.2c.41-2.85,2.38-4.28,5.5-4.35,3.26-.07,5.36,1.43,5.36,4.41,0,2.44-1.43,3.53-3.53,4.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-18",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M290.38,38.99c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cO-6",
    "data-name": "cO",
    className: "cls-12-soa-p1",
    d: "M296.49,36.88c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM297.1,38.51c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cM-4",
    "data-name": "cM",
    className: "cls-12-soa-p1",
    d: "M177.46,62.55c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM179.7,71.04c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-16",
    "data-name": "aP",
    className: "cls-12-soa-p1",
    d: "M201.29,76.95c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM194.98,75.79c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-19",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M213.04,68.32c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-12",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M217.39,76.2c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dk",
    className: "cls-12-soa-p1",
    d: "M232.33,66.49l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "an-2",
    "data-name": "an"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cY-7",
    "data-name": "cY",
    className: "cls-12-soa-p1",
    d: "M251.75,66.56c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dc-8",
    "data-name": "dc",
    className: "cls-12-soa-p1",
    d: "M264.99,62.35c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM264.99,77.76c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cZ-6",
    "data-name": "cZ",
    className: "cls-12-soa-p1",
    d: "M288.41,79.39l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM285.83,72.67l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-soa-p1",
    d: "M143.1,186.5c0-3.31,2.69-6,6-6h168c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-168c-3.31,0-6-2.69-6-6h0v-108Z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "aF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dl",
    className: "cls-12-soa-p1",
    d: "M192.98,215.06v-7.81h-9.1v7.81h-2.24v-16.84h2.24v7.13h9.1v-7.13h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-17",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M198.82,199.37v-2.04h2.17v2.04h-2.17ZM198.82,215.06v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-7",
    "data-name": "aT",
    className: "cls-12-soa-p1",
    d: "M214.57,202.16c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM208.93,213.56c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dd-2",
    "data-name": "dd",
    className: "cls-12-soa-p1",
    d: "M223.33,203.58c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba-6",
    "data-name": "ba",
    className: "cls-12-soa-p1",
    d: "M238.13,215.06v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-19",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M248.66,201.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM252.19,207.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cP-2",
    "data-name": "cP",
    className: "cls-12-soa-p1",
    d: "M262.78,215.06h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-20",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M274.46,201.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM277.99,207.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-7",
    "data-name": "ba",
    className: "cls-12-soa-p1",
    d: "M282.88,215.06v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aH"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dh-2",
    "data-name": "dh",
    className: "cls-12-soa-p1",
    d: "M189.07,235.5c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM182.49,234.75c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM182.49,242.56c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-20",
    "data-name": "aY",
    className: "cls-12-soa-p1",
    d: "M202.25,233.32c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-18",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M204.21,228.71v-2.04h2.17v2.04h-2.17ZM204.21,244.39v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-21",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M214.74,231.22c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM218.27,236.72c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cW-2",
    "data-name": "cW",
    className: "cls-12-soa-p1",
    d: "M228.39,228.5c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-19",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M229.95,228.71v-2.04h2.17v2.04h-2.17ZM229.95,244.39v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-19",
    "data-name": "aU",
    className: "cls-12-soa-p1",
    d: "M241.63,231.22c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-8",
    "data-name": "aT",
    className: "cls-12-soa-p1",
    d: "M259.28,231.49c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM253.65,242.9c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aI"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bb-13",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M271.64,241.2c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-14",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M281.21,231.22c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM281.15,243.03c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "an-3",
    "data-name": "an"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cY-8",
    "data-name": "cY",
    className: "cls-12-soa-p1",
    d: "M219.87,260.89c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dc-9",
    "data-name": "dc",
    className: "cls-12-soa-p1",
    d: "M233.11,256.68c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM233.11,272.09c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cZ-7",
    "data-name": "cZ",
    className: "cls-12-soa-p1",
    d: "M256.53,273.72l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM253.95,267l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-soa-p1",
    d: "M233.1,121.5v42.12"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M233.6,121.5h-1v-.5h1v.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-soa-p1",
    d: "M233.1,178.38l-4.63-14.26h9.28l-4.65,14.26Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-soa-p1",
    d: "M233.1,301.5v42.12"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M233.6,301.5h-1v-.5h1v.5Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-soa-p1",
    d: "M233.1,358.38l-4.63-14.26h9.28l-4.65,14.26Z"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-soa-p1",
    d: "M143.1,366.5c0-3.31,2.69-6,6-6h168c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-168c-3.31,0-6-2.69-6-6v-108Z"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "aJ"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dm",
    className: "cls-12-soa-p1",
    d: "M179.06,398.04c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82ZM167.51,401.3c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-22",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M187.61,396.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM191.14,402.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-8",
    "data-name": "aZ",
    className: "cls-12-soa-p1",
    d: "M200.92,398.58c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-23",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M213.42,396.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM216.95,402.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-20",
    "data-name": "aS",
    className: "cls-12-soa-p1",
    d: "M221.83,394.37v-2.04h2.17v2.04h-2.17ZM221.83,410.06v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cP-3",
    "data-name": "cP",
    className: "cls-12-soa-p1",
    d: "M232.9,410.06h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-24",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M244.58,396.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM248.11,402.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ-9",
    "data-name": "aZ",
    className: "cls-12-soa-p1",
    d: "M264.68,398.58c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-15",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M277.17,396.88c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM277.11,408.7c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-17",
    "data-name": "bc",
    className: "cls-12-soa-p1",
    d: "M293.13,400.35c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-14",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M300.19,406.87c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dn",
    className: "cls-12-soa-p1",
    d: "M212.4,437.29c-.75,1.49-1.97,2.38-4.07,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.01,1.15-6.72,4.75-6.79,2.17-.07,3.26.95,4.07,2.24,0-.75-.07-1.63.14-2.17h2.04l-.07,18.2h-2.17l.07-7.2ZM208.87,437.96c2.78,0,3.46-2.24,3.46-5.16s-.54-4.96-3.4-4.96-3.12,2.38-3.12,5.09.34,5.02,3.06,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cN-4",
    "data-name": "cN",
    className: "cls-12-soa-p1",
    d: "M221.83,439.66c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-16",
    "data-name": "aV",
    className: "cls-12-soa-p1",
    d: "M236.5,426.22c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM236.43,438.03c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-15",
    "data-name": "bb",
    className: "cls-12-soa-p1",
    d: "M247.3,436.2c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-25",
    "data-name": "aX",
    className: "cls-12-soa-p1",
    d: "M256.87,426.22c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM260.4,431.72c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-soa-p1",
    d: "M233.1,481.25v25.15"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M233.36,481.26h-.5v-.26h.5v.26Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-soa-p1",
    d: "M233.1,520.92l-4.63-14.27h9.28l-4.65,14.27Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M723.6,1449.22l-.07,1-.24,1-.4.93-.53.87-.66.77-.77.66-.87.53-.95.38-1,.24-1,.08h-173l-.87.07-.83.2-.8.33-.74.45-.64.56-.56.67-.46.73-.32.8-.2.84-.08.88v34.43h-1v-34.47l.08-1,.24-1,.4-.93.52-.87.67-.78.77-.66.87-.54.93-.4,1-.22,1-.08h173l.88-.07.84-.2.8-.33.74-.46.65-.56.56-.65.44-.74.33-.8.2-.84.07-.88v-313h1v313.06Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M723.6,1136.2h-1v-.5h1v.5Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M723.63,1136.22h-1.05v-.56h1.05v.56ZM722.63,1135.72v.45h.95v-.46h-.95Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M538.1,1510.4l-4.63-14.25h9.28l-4.65,14.25Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M538.1,1512.03l-5.32-16.38h10.65l-5.33,16.38ZM534.16,1496.65l3.94,12.14,3.95-12.15h-7.89Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M233.6,1449.18l.07.88.2.84.34.8.46.73.56.65.65.57.75.45.8.33.83.2.88.07h293l1,.08,1,.23.94.4.87.54.77.66.66.78.54.87.4.94.23.98.07,1v34.47h-1v-34.43l-.06-.88-.2-.84-.34-.8-.45-.73-.57-.66-.65-.55-.74-.45-.8-.33-.84-.2-.88-.07H239.09l-1-.08-.98-.24-.95-.4-.88-.52-.77-.67-.66-.78-.55-.87-.4-.94-.23-1-.08-.98v-87.03h1v86.98Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M233.6,1362.2h-1v-.5h1v.5Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M233.63,1362.23h-1.05v-.57h1.05v.57ZM232.63,1361.71v.48h.95v-.47h-.95Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M538.1,1510.4l-4.63-14.25h9.28l-4.65,14.25Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M538.1,1512.03l-5.32-16.38h10.65l-5.33,16.38ZM534.16,1496.65l3.94,12.14,3.95-12.15h-7.89Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M538.6,1688.3h-1v-54.77h1v54.77Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M538.6,1633.54h-1v-.5h1v.5Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M538.63,1633.57h-1.05v-.56h1.05v.56ZM537.63,1633.07v.45h.95v-.47l-.95.02Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-soa-p1",
    d: "M538.1,1703.07l-4.63-14.27h9.28l-4.65,14.27Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-soa-p1",
    d: "M538.1,1704.7l-5.32-16.4h10.65l-5.33,16.4ZM534.16,1689.3l3.94,12.15,3.96-12.15h-7.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoaPhase1);
export default __webpack_public_path__ + "static/media/SOA_Phase_1.9d9a67e3ce7a1f26c480bdfcaf44e8b7.svg";
export { ForwardRef as ReactComponent };